import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import FormSection from "./FormSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/servicios",
        label: "Servicios",
    },
    {
        path: "/servicios/spa",
        label: "Spa",
    },
    {
        path: "/crear",
        label: "Crear",
        isActive: true
    }
]

function CrearServicioSpa(){
    return (
        <Page title="Registro de Servicio" description="Creación de servicio de spa." breadCrumbs={breadCrumbs}>
            <FormSection />
        </Page>
    );
}

export default CrearServicioSpa;